<template>
  <div class="action-bar">
    <div class="add-btn" @click="showAddProduct" v-if="add">
      <span class="add-icon">+</span>
      <span>Add Product</span>
    </div>
    <div class="search-btn" @click="showSearch" v-if="search">
      <!--      <div class="search-btn-con"></div>-->
      <svg class="search-icon" viewBox="0 0 1024 1024" width="0.36rem" height="0.36rem">
        <path d="M448 192a256 256 0 1 1 0 512 256 256 0 0 1 0-512z m0-85.333a341.333 341.333 0 1 0 0 682.666 341.333 341.333 0 0 0 0-682.666z" fill="#333"/>
        <path d="M723.627 637.867l213.333 213.333-60.288 60.288-213.333-213.333z" fill="#333"/>
      </svg>
      <el-input v-model="keyword" placeholder="Search" @input="input"></el-input>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ph-compare-action-bar',
  props: {
    add: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      timer: null,
    }
  },
  methods: {
    showAddProduct(){
      this.$emit('showAddProduct')
    },
    showSearch(){
      this.$emit('showSearch')
    },
    input(value){
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.$emit('input', value)
      }, 300)
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}

</script>



<style scoped>
/* 操作栏 */
.action-bar {
  //display: flex;
  padding: 0.24rem 0.32rem;
  background: #fff;
  align-items: center;
}

.add-btn {
  flex: 1;
  height: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.12rem;
  background: #f5f5f5;
  border-radius: 0.12rem;
  font-size: 0.3rem;
  color: #333;
  cursor: pointer;
  position: relative;
  //clip-path: polygon(0 0, 100% 0%, 95.5% 100%, 0% 100%);
}

.add-icon {
  font-size: 0.36rem;
  font-weight: 600;
}

.search-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 .3rem;
  //border: 1px solid #e0e0e0;
  background-color: #f2f2f2;
  border-radius: 0.12rem;
  font-size: 0.3rem;
  color: #333;
  cursor: pointer;
  position: relative;
}
.search-btn-con {
  width: 1.56rem;
  height: 0.67rem;
  background-color: #ffffff;
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(11% 0, 100% 0%, 100% 100%, 0% 100%);
  padding: 0 0 0 .4rem;
}

</style>

<style>
.action-bar .search-btn .el-input__inner {
  border: 0;
  padding: 0 .05rem;
  font-size: .3rem;
  background-color: #f2f2f2;
}
.action-bar .search-btn .el-input__inner::placeholder {
  color: #333333!important;
  font-size: .3rem;
  height: 100%;
}
</style>